<microsec-loading-overlay [isLoading]="!!isLoading">
  <div>
    @if (!!form) {
      <form class="no-wrapper" [formGroup]="form" (ngSubmit)="onSubmit()">
        <p-tabs class="microsec-dashboard-tab active-scan-tab" [(value)]="activeTabIndex">
          <p-tablist>
            <p-tab [value]="0">Selected Devices</p-tab>
            <p-tab [value]="1">Overview</p-tab>
            <p-tab [value]="2">Compliance</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <div class="scroll-panel">
                <div class="my-2 mx-6 flex flex-col gap-4">
                  <div class="flex flex-col gap-3">
                    <label
                      >Below are the selected devices for bulk edit. To modify the list, please cancel and re-select devices from the main Devices
                      page.</label
                    >
                    <microsec-card [isTableCard]="true">
                      <microsec-common-table
                        [totalRecords]="selectedDevices.length"
                        [cols]="cols"
                        [values]="selectedDevices"
                        [cellTemplate]="cellTemplate"
                        [dataKey]="'id'"
                        itemName="Selected Device" />
                    </microsec-card>
                  </div>
                </div>
              </div>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <div class="scroll-panel">
                <div class="my-2 mx-6 flex flex-col gap-5">
                  <label>
                    Edit specific fields for multiple devices simultaneously. Saving these changes will overwrite the original values in the
                    respective fields for the selected devices.
                  </label>
                  <app-bulk-edit-devices-overview-form #bulkEditForm />
                </div>
              </div>
            </p-tabpanel>
            <p-tabpanel [value]="2">
              <div class="scroll-panel">
                <div class="my-2 mx-6 flex flex-col gap-2">
                  <div class="grid grid-cols-12">
                    <label class="col-span-4">Enter Compliance Details</label>
                    <div class="col-span-8">
                      <p-checkbox
                        [binary]="true"
                        (onChange)="toggleCompliance($event)"
                        [formControlName]="FORM_PARAMS.IS_COMPLIANCE_NEEDED"
                        [disabled]="false" />
                    </div>
                  </div>
                  @if (!!form.get(FORM_PARAMS.IS_COMPLIANCE_NEEDED)?.value) {
                    <app-compliance-details-field [readOnly]="false" [(securityLevel)]="securityLevel" [(isValid)]="complianceDetailsValid" />
                  }
                </div>
              </div>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
        <div class="mb-3 mx-5">
          <div class="flex flex-row items-center justify-between">
            <div>
              @if (activeTabIndex !== 0) {
                <p-button severity="primary" type="button" label="Reset To Default" (onClick)="resetValues()" />
              }
            </div>
            <div class="flex flex-row items-center justify-end gap-2">
              <p-button severity="secondary" type="button" (onClick)="onCancel()" label="Cancel" />
              <p-button type="submit" [label]="SAVE_CHANGES_LABEL" severity="success" [disabled]="!isValid" />
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</microsec-loading-overlay>
